<mat-card appearance="outlined" >
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Plantilla Escrito</h2>
      <app-button-new  matTooltip="Crear" (click)="openDialog({ accion: AccionesDialog.Agregar, entidad: {} })"></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <mat-card-content>
    <form [formGroup]="plantillaForm">
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Titulo</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Titulo" />
          </mat-form-field>
        </div>

        <div class="col-sm-12 col-md-8 col-lg-5">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" maxlength="200" style="text-transform: uppercase" formControlName="Descripcion" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spBusquedaTiposEscrito" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Tipo Escrito</mat-label>
            <mat-select placeholder="Seleccione opcion" multiple formControlName="IdTipoEscrito">
              <mat-option [value]="tipoEscrito.id" *ngFor="
                  let tipoEscrito of tiposEscrito;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ tipoEscrito.descripcion }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-auto">
          <app-button-filter-table (click)="filtrar()"></app-button-filter-table>
        </div>
        <div class="col-auto">
          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-content>
   <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <div class="row align-items-center">

      <div class="col-auto d-flex align-items-center">
        <!-- <app-button-action *ngIf="data"
          [actions]="[
      { label: 'Solicitar clave', icon: 'key', handler: solicitarClavePorCorreo, roles: ['Expedientes.Modificar'] }]"></app-button-action> -->

      </div>
      <!-- <div class="col-auto d-flex align-items-center">
        <app-button-export-file *ngIf="hasData" (click)="exportarTabla()"></app-button-export-file>
      </div> -->
      <!-- Espaciado intermedio -->
      <div class="col"></div>

      <!-- Campo de búsqueda alineado a la derecha -->
      <div class="col-lg-4 col-sm-12 text-end">
        <mat-form-field appearance="outline" *ngIf="hasData" class="">
          <mat-icon matPrefix>search</mat-icon>
          <mat-label>Buscar</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
        </mat-form-field>
      </div>
    </div>

    <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="hasData" matSort matSortStart="asc">
      <ng-container matColumnDef="titulo">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          <strong>Titulo</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item">
          {{
          item.titulo == undefined ? "" : (item.titulo | uppercase)
          }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descripcion">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          <strong>Descripción</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item">
          {{
          item.descripcion == undefined
          ? ""
          : (item.descripcion | uppercase)
          }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tipoEscrito">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          <strong>Tipo Escrito</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item">
          {{
          item.tipoEscrito.Descripcion == undefined
          ? ""
          : (item.tipoEscrito.Descripcion | uppercase)
          }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaCreacion">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          <strong>Fecha Creación</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item">
          {{
          item.fechaCreacion == undefined ? "" : (item.fechaCreacion | date)
          }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fechaModificacion">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          <strong>Fecha Modificación</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item">
          {{
          item.fechaModificacion == undefined
          ? ""
          : (item.fechaModificacion | date)
          }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="accion">
        <mat-header-cell mat-header-cell *matHeaderCellDef>
          <strong>Acción</strong>
        </mat-header-cell>
        <mat-cell mat-cell *matCellDef="let item" class="action-link">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openDialog({ accion: AccionesDialog.Ver, entidad: item })">
              <mat-icon>visibility</mat-icon>
              <span>Ver</span>
            </button>
            <button mat-menu-item (click)="openDialog({ accion: AccionesDialog.Modificar, entidad: item })">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="openDialog({ accion: AccionesDialog.Eliminar, entidad: item })">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
    </table>
    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>
    <mat-paginator showFirstLastButtons class="paginator" *ngIf="hasData" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
    </mat-paginator>
  </mat-card-content>
</mat-card>
